import { FlatEntry } from 'services/cms/flattenContentful';
import { Page } from 'api/contentful/contentTypes.cloverdotcom';

/**
 * Determines the depth of references to request based on whether the page includes a sheet modal.
 *
 * For pages that include a sheet modal (`includeSheetModal` property is true), the function
 * returns a depth of 9 to ensure deep enough data retrieval. For all other pages or in cases
 * where the `includeSheetModal` property is not true, it defaults to a depth of 6.
 *
 * This differentiation in depth allows for optimized data fetching, ensuring that more extensive
 * data is fetched only when necessary, specifically for the functionality provided by sheet modals.
 *
 * @param {Partial<FlatEntry<Page>>} entry - The page entry object which may optionally contain
 *                                           the `includeSheetModal` property.
 * @returns {number} The depth of the references to request: 9 if sheet modal is included,
 *                   otherwise 6.
 */
export const getRequestDepth = (entry: Partial<FlatEntry<Page>>): number =>
  entry.includeSheetModal === true ? 9 : 6;
